import { render, staticRenderFns } from "./LayerImportExtraAttributes.vue?vue&type=template&id=f8ace370&scoped=true"
import script from "./LayerImportExtraAttributes.vue?vue&type=script&lang=js"
export * from "./LayerImportExtraAttributes.vue?vue&type=script&lang=js"
import style0 from "./LayerImportExtraAttributes.vue?vue&type=style&index=0&id=f8ace370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ace370",
  null
  
)

export default component.exports